import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import { HitmakerService } from 'src/app/core/services/hitmaker/hitmaker.service';

@Component({
  selector: 'app-stage-update',
  templateUrl: './stage-update.component.html',
  styleUrls: ['./stage-update.component.css']
})
export class StageUpdateComponent implements OnInit {

  movieId: any;
  stageName: any;
  stageId: any;
  image: any;
  admin = false;
  details: any;
  title: any;
  url: any;
  updatedImage: any;
  order: any;
  isNewImageSelected = false;
  modifiedStageName : any;

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private hitmakerservice: HitmakerService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    public auth: AuthenticationService,) {

  }

  uploadStage = this.formBuilder.group({
    videoUrl: [''],
    mainTitle: [''],
    thumbnail: [''],
    sequence: [''],
  });

  ngOnInit(): void {
  this.auth.checkUserAuthenticated().subscribe((data: any) => {
    this.admin = !!data.adminRole;
  });
  this.movieId = this.activatedRoute.snapshot.params['id'];
  this.stageName = this.activatedRoute.snapshot.params['stage-name'];
  this.stageId = this.activatedRoute.snapshot.params['stage-id'];
  
    if (this.stageName === 'casting') {
      this.modifiedStageName = 'CASTING';
    } else if (this.stageName === 'pre-production') {
      this.modifiedStageName = 'PRE_PRODUCTION';
    } else if (this.stageName === 'filming') {
      this.modifiedStageName = 'FILMING';
    } else if (this.stageName === 'post-production') {
      this.modifiedStageName = 'POST_PRODUCTION';
    } else if (this.stageName === 'release') {
      this.modifiedStageName = 'RELEASE';
    }

  this.hitmakerservice.getHitmakerStageData(this.movieId, this.modifiedStageName, this.stageId).
  subscribe((data: any)=> {
    this.uploadStage.get('videoUrl').setValue(data.contentUrl);
    this.uploadStage.get('mainTitle').setValue(data.stageContentLabel);
    this.uploadStage.get('thumbnail').setValue(data.thumbnailURL);
    this.uploadStage.get('sequence').setValue(data.order);
  })
}


  postHitmakerVideo() {

    if (this.uploadStage.invalid) {
      alert("Please enter all required values.");
      return;
    }

    const data = {
      url: this.uploadStage.get('videoUrl').value,
      title: this.uploadStage.get('mainTitle').value,
      order: this.uploadStage.get('sequence').value,
    };

    const formData = new FormData();

    if (this.image !== null) {
      formData.set('thumbnailImage', this.image);
    }
    
    this.spinner.show();
    this.hitmakerservice.updateHitmakerStageData(this.movieId, this.stageId, data, formData)
      .subscribe(response => {
        if (response) {
          this.spinner.hide();
          alert("Uploaded Successfully!!");
          this.router.navigate(['/hitmaker/' + this.movieId + '/stage/' + this.stageName]);
        } else {
          alert("Please Upload a valid url.");
        }
      },
        (error) => {
          this.spinner.hide();
          alert("Please Upload a valid url.");
        }
      );
  }

  onThumbnailSelect33(file: File): void {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const eventImgControl = this.uploadStage.get(`thumbnail`);
      eventImgControl.setValue(reader.result);
    };
    this.image = file;
  }

}
